module.exports = class AccountService {

  isDoctor(account) {
    let kind;

    if (account.kind && account.kind.mnemonic) {
      kind = account.kind.mnemonic;
    } else {
      kind = account.kind;
    }

    return _.includes([
      'doctor',
      'retired',
      'fellow',
      'resident1',
      'resident2',
      'resident3',
      'resident4',
      'resident5',
      'resident6',
      'resident7',
    ], kind);
  }
};



// WEBPACK FOOTER //
// ./main/services/account-service.js